module.exports = __webpack_public_path__ + "static/media/tff.96c64e15.png";